/* SET STATE */
export const SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL = "SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL"

/* LABREQUESTDELIVERYRESULTPARTIALS */
export const GET_LABREQUESTDELIVERYRESULTPARTIALS = "GET_LABREQUESTDELIVERYRESULTPARTIALS"
export const GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS = "GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS"
export const GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL = "GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL"

/* LABREQUESTDELIVERYRESULTPARTIAL */
export const GET_LABREQUESTDELIVERYRESULTPARTIAL = "GET_LABREQUESTDELIVERYRESULTPARTIAL"
export const GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS = "GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS"
export const GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL = "GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL"

/**
 * ADD LABREQUESTDELIVERYRESULTPARTIAL
 */
 export const ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL = "ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL"
 export const ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS = "ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS"
 export const ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL = "ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL"

 /**
 * UPDATE LABREQUESTDELIVERYRESULTPARTIAL
 */
export const UPDATE_LABREQUESTDELIVERYRESULTPARTIAL = "UPDATE_LABREQUESTDELIVERYRESULTPARTIAL"
export const UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS = "UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS"
export const UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL = "UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL"

/**
 * DELETE LABREQUESTDELIVERYRESULTPARTIAL
 */
export const DELETE_LABREQUESTDELIVERYRESULTPARTIAL = "DELETE_LABREQUESTDELIVERYRESULTPARTIAL"
export const DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS = "DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS"
export const DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL = "DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL"
